module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "history"
  }, [_c('h1', {
    staticClass: "header-title"
  }, [_vm._v("History")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading-history",
    attrs: {
      "element-loading-text": "Loading the history..."
    }
  }, [_c('ol', {
    staticClass: "history-list"
  }, [_vm._l((_vm.unconfirmeds), function(event) {
    return _c('history-item', {
      key: event.hash,
      attrs: {
        "title": event.title,
        "message": event.message,
        "time": event.calcTime,
        "score": event.score,
        "status": event.status
      }
    })
  }), _vm._v(" "), _vm._l((_vm.timeline), function(event) {
    return _c('history-item', {
      key: event.hash,
      attrs: {
        "title": event.title,
        "message": event.message,
        "time": event.calcTime,
        "score": event.score
      }
    })
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38cf2b5c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/History.vue
// module id = 1136
// module chunks = 14